/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Embark
 * @since   1.0.0
 */
import './plugins/sly.min.js';
import './modules/theme/polyfills';
import './modules/theme/webfonts';
import './modules/theme/images';
import './modules/theme/object-fit-videos';
import './modules/theme/lightboxes';
import './modules/theme/forms';
import './modules/theme/scroll-to';
// import './modules/theme/sticky-header';
import './modules/theme/main-menu';
import './modules/theme/comment-reply';
import './modules/theme/header-search';
import './modules/theme/sly.js';
import './modules/theme/sliders.js';
import './modules/theme/divisions-carousel.js';
